import { render, staticRenderFns } from "./PropertiesFilter.vue?vue&type=template&id=63e602ad"
import script from "./PropertiesFilter.vue?vue&type=script&lang=js"
export * from "./PropertiesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports